// Default Chart of Accounts for a new project.
// Each account has: code, name, type, normal side ("dr" or "cr"), category.
// type drives which financial statement the account flows into.
//   asset, liability, equity → Balance Sheet
//   revenue, cogs, expense, other_income → P&L

export const ACCOUNT_TYPES = {
  asset: { side: "dr", statement: "bs" },
  liability: { side: "cr", statement: "bs" },
  equity: { side: "cr", statement: "bs" },
  revenue: { side: "cr", statement: "pl" },
  cogs: { side: "dr", statement: "pl" },
  expense: { side: "dr", statement: "pl" },
  other_income: { side: "cr", statement: "pl" },
  other_expense: { side: "dr", statement: "pl" },
};

export const DEFAULT_COA = [
  // === Assets (1xxxxx) ===
  { code: "100010", name: "Bank - Transactional", type: "asset", deductible: null },
  { code: "100020", name: "Bank - Money Market / Call", type: "asset", deductible: null },
  { code: "100030", name: "Bank - Other (Stokvel / Savings)", type: "asset", deductible: null },
  { code: "100040", name: "Petty Cash", type: "asset", deductible: null },
  { code: "110010", name: "Trade Receivables", type: "asset", deductible: null },
  { code: "110020", name: "Loan Receivable", type: "asset", deductible: null },
  { code: "120010", name: "Inventory", type: "asset", deductible: null },
  { code: "130010", name: "Computer Equipment", type: "asset", deductible: null },
  { code: "130020", name: "Office Equipment", type: "asset", deductible: null },
  { code: "130030", name: "Vehicles", type: "asset", deductible: null },
  { code: "130090", name: "Accumulated Depreciation", type: "asset", deductible: null },

  // === Liabilities (2xxxxx) ===
  { code: "200010", name: "Shareholder's Loan", type: "liability", deductible: null },
  { code: "200020", name: "Third-Party Loan", type: "liability", deductible: null },
  { code: "200030", name: "Bank Loan / Finance", type: "liability", deductible: null },
  { code: "210010", name: "VAT Control", type: "liability", deductible: null },
  { code: "210020", name: "PAYE / UIF / SDL Payable", type: "liability", deductible: null },
  { code: "220010", name: "Trade Payables", type: "liability", deductible: null },

  // === Equity (3xxxxx) ===
  { code: "300010", name: "Share Capital", type: "equity", deductible: null },
  { code: "300020", name: "Retained Earnings", type: "equity", deductible: null },
  { code: "300030", name: "Current Year Earnings", type: "equity", deductible: null },

  // === Revenue (5xxxxx) ===
  { code: "500010", name: "Sales / Business Income", type: "revenue", deductible: null },
  { code: "500020", name: "Interest Income", type: "other_income", deductible: null },
  { code: "500030", name: "Refunds Received", type: "other_income", deductible: null },
  { code: "500040", name: "Consulting Income", type: "revenue", deductible: null },
  { code: "500080", name: "Rental Income", type: "revenue", deductible: null },

  // === Cost of Sales (600xxx) ===
  { code: "600010", name: "Cost of Sales - Purchases", type: "cogs", deductible: true },

  // === Operating Expenses (61xxxx) ===
  { code: "610080", name: "Directors Remuneration", type: "expense", deductible: true },
  { code: "610100", name: "Salaries & Wages", type: "expense", deductible: true },
  { code: "610120", name: "Rates", type: "expense", deductible: true },
  { code: "610130", name: "Utilities (Water, Electricity)", type: "expense", deductible: true },
  { code: "610140", name: "Repairs & Maintenance", type: "expense", deductible: true },
  { code: "610160", name: "Insurance", type: "expense", deductible: true },
  { code: "610170", name: "Transport / Travel", type: "expense", deductible: true },
  { code: "610180", name: "Software Subscriptions", type: "expense", deductible: true },
  { code: "610190", name: "Internet & Hosting", type: "expense", deductible: true },
  { code: "610260", name: "Software Expenses", type: "expense", deductible: true },
  { code: "610290", name: "Accounting & Admin Fees", type: "expense", deductible: true },
  { code: "610350", name: "Sundry / Compliance Fees", type: "expense", deductible: true },
  { code: "610380", name: "Bank Charges & Fees", type: "expense", deductible: true },
  { code: "610400", name: "Food & Entertainment", type: "expense", deductible: false },
  { code: "610410", name: "Cash Withdrawals (no docs)", type: "expense", deductible: false },
  { code: "610500", name: "Depreciation", type: "expense", deductible: true },
];

export function indexCOA(coa) {
  const byCode = {};
  coa.forEach((a) => { byCode[a.code] = a; });
  return byCode;
}

export function accountType(coa, code) {
  const a = (Array.isArray(coa) ? indexCOA(coa) : coa)[code];
  return a ? a.type : null;
}
